import React from 'react';
import { Route, Switch } from 'react-router-dom';
import List from './List';

export default class Dashboard extends React.Component {
  render = () => {
    const { match } = this.props;
    return (
      <div>
        <Switch>
          <Route exact path={match.url} component={List}/>
        </Switch>
      </div>
    );
  };
}



// WEBPACK FOOTER //
// ./src/components/Dashboard/index.js